import { IServices } from "@netent/origin";
import { IQuickSpinState } from "@netent/playui";
import { FeatureStateCreator } from "../../types";

export const quickSpinState: FeatureStateCreator<IQuickSpinState> = (
  services: IServices
): IQuickSpinState => {
  const isQuickSpinAvailable = services.game.isQuickSpinAvailable();

  return isQuickSpinAvailable
    ? {
        enabled: services.gameSettings.isSettingEnabled("quickSpin"),
        active: services.gameSettings.getSetting("quickSpin")
      }
    : null;
};
